<template>
  <div :class="{ inline: editableCountry, TA:isTestAchat }">
    <v-select
      v-if="editableCountry"
      class="select tel"
      :options="options"
      :searchable="false"
      :components="{ Deselect }"
      :reduce="(options) => options.value"
      label="value"
      :value="country"
      @input="changeCountry($event)"
    >
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">{{ option.value }}</div>
      </template>
      <template slot="option" slot-scope="option">
        <div class="option d-center">
          <img
            :alt="option.flag"
            class="icon"
            :src="require(`@/assets/flags/${option.flag}.png`)"
          />
          {{ option.value }}
        </div>
      </template>
    </v-select>
    <v-select
      v-if="isBelgian"
      class="select locality"
      :class="{ country: editableCountry }"
      :placeholder="$t('Situation.PersonalDetails.zipCode')"
      @search="fetchOptions"
      :filterable="false"
      :options="localities"
      label="label"
      :components="{ Deselect }"
      :value="value"
      :reduce="(localities) => localities.value"
      @input="setSelected"
      @search:blur="$emit('blur')"
    >
      <!-- <template slot="selected-option" slot-scope="option">
        <div class="selected d-center" v-if="isInList" :key="isInList">{{ value.zipCode }} - {{ value.town }}</div>
      </template> -->
      <template slot="no-options">
        {{ $t("Situation.PersonalDetails.noLocality") }}
      </template>
      <template #spinner="{ loading }">
        <SvgIcon v-if="loading" class="loading" icon="loading"></SvgIcon>
      </template>
    </v-select>
    <div class="country locality inline" v-if="!isBelgian">
      <input
        name="zipCode"
        class="input zipcode"
        type="number"
        :placeholder="$t('Contract.DeliveryAddress.zipCode')"
        @blur="$emit('blur')"
        v-bind:value="value ? value.zipCode : null"
        v-on:input="changeZipcode($event.target.value)"
      />
      <input
        name="town"
        class="input town"
        type="number"
        :placeholder="$t('Contract.DeliveryAddress.town')"
        @blur="$emit('blur')"
        v-bind:value="value ? value.town : null"
        v-on:input="changeTown($event.target.value)"
      />
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import geoService from "@/services/geoService";
import { mapGetters } from "vuex";
import streetService from "@/services/streetService";

export default {
  data() {
    return {
      options: [
        { flag: "be", value: "BE" },
        { flag: "fr", value: "FR" },
        { flag: "lu", value: "LU" },
      ],
    };
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    isBelgian() {
      return this.country === 'BE'
    },
    localities: {
      get() {
        return this.$store.state.common.localities;
      },
      set(value) {
        this.$store.commit("common/setLocalities", value);
      },
    },
    Deselect() {
      return null;
    },
  },
  props: {
    country: {
      type: String,
      required: false,
      default: "BE",
    },
    editableCountry: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: null,
    },
  },
  methods: {
    setSelected(value) {
      this.$emit("input", value);
    },
    async getTowns(search) {
      geoService.cancelRequest();
      let response = await geoService.getProviders(search);

      if(!response){
        this.localities = [];
        this.$store.commit("common/setLocalities", []);
        this.$store.commit("contract/setAddressLocality", null);

        this.$store.commit(
          "common/setElecProviders",
          null
        );
        this.$store.commit(
          "common/setGasProviders",
          null
        );
        this.$emit("input", null);

        return;
      }
      this.$store.commit(
        "common/setElecProviders",
        response.energyProviders.electricity
      );
      this.$store.commit(
        "common/setGasProviders",
        response.energyProviders.gas
      );
      this.localities = [];
      let localities = [];
      let idTown = null;

      if (this.country === 'BE' && response.region === 'wl') {
        let zones = await streetService.getWalloniaZone(search);
        let result = zones.candidates ? zones.candidates.find(e => e.city && e.city.ident) : null;
        if (result) {
          idTown = result.city.ident;
        }
      }

      response.towns.forEach((town) => {
        localities.push({
          label: `${search} - ${town}`,
          value: {
            zipCode: search,
            town: town,
            region: response.region,
            ident: idTown,
          },
        });
      });

      this.$emit("input", localities[0].value);
      this.localities = localities;
    },
    async fetchOptions(search, loading) {
      if (search.length !== 4) {
        loading(false);
        return;
      }
      loading(true);
      await this.getTowns(search);
      loading(false);
    },
    changeCountry(eventValue) {
      this.$emit('changecountry', eventValue);
    },
    changeZipcode(eventValue) {
      let value = this.value;
      value.zipCode = eventValue;
      this.$emit('input', value);
    },
    changeTown(eventValue) {
      let value = this.value;
      value.town = eventValue;
      this.$emit('input', value);
    }
  },
  components: {
    vSelect,
  },
  created() {
    if (this.value && this.country === 'BE') {
      this.getTowns(this.value.zipCode);
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .select .vs__dropdown-toggle {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  padding: 1px;
  border-radius: 4px;
  border: 2px solid $yellow;
  min-width: 100px;
}

/deep/ .select .vs__dropdown-menu {
  background: $white;
  border: 2px solid $yellow;
  border-top: 0;
  color: $black;
}

/deep/ .vs__search {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  z-index:0;
  &::placeholder {
    color: $grey;
  }
}

.tel {
  flex: 0 0 auto;
  align-self: stretch;

  /deep/ &.tel .vs__dropdown-toggle {
    border: 2px solid $yellow !important;
  }
}

/deep/ .tel .vs__dropdown-toggle {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  font-size: 0.95rem;
  padding: 0;
  // padding: 5px 10px;
  border-radius: 4px 0 0 4px;
  border: 2px solid $yellow;
  background: $yellow;
  width: 85px;
  height: 100%;

  .vs__search {
    display: none;
  }

  .selected {
    position: relative;
  }
}

.option {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    height: 1rem;
  }
}

.country {
  flex: 1;

  .town {
    flex: 1;
    border-left: 0;
    border-radius: 0 4px 4px 0!important;
  }
  .zipcode {
    border-radius: 0!important;
    flex: 1;
  }
}

/deep/ .country .vs__dropdown-toggle {
  border-radius: 0 4px 4px 0 !important;
}

.TA {
  /deep/ .select .vs__dropdown-toggle {
    font-family: 'Lato', Helvetica, Arial, sans-serif;
    border: 2px solid $pink!important;
  }

  /deep/ .select .vs__dropdown-menu {
    border: 2px solid $pink!important;
  }

  /deep/ .vs__search {
    font-family: "Lato", Helvetica, Arial, sans-serif;
  }

  .tel {
    /deep/ &.tel .vs__dropdown-toggle {
      border: 2px solid $pink !important;
    }
  }

  /deep/ .tel .vs__dropdown-toggle {
    font-family: "Lato", Helvetica, Arial, sans-serif;
    border: 2px solid $pink;
    background: $pink;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form/BecomeFields/LocalityField.vue